var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 412,
    height: 240,
    viewBox: "0 0 412 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 412,
    height: 240,
    fill: "var(--card-thumbnail-bg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M181 45V28.3334H231V45H181ZM197.667 136.667H214.333V86.6667H197.667V136.667ZM206 203.333C195.722 203.333 186.033 201.356 176.933 197.4C167.839 193.439 159.889 188.056 153.083 181.25C146.278 174.444 140.894 166.494 136.933 157.4C132.978 148.3 131 138.611 131 128.333C131 118.056 132.978 108.367 136.933 99.2667C140.894 90.1723 146.278 82.2223 153.083 75.4167C159.889 68.6112 167.839 63.2306 176.933 59.275C186.033 55.3139 195.722 53.3334 206 53.3334C214.611 53.3334 222.875 54.7223 230.792 57.5C238.708 60.2778 246.139 64.3056 253.083 69.5834L264.75 57.9167L276.417 69.5834L264.75 81.25C270.028 88.1945 274.056 95.625 276.833 103.542C279.611 111.458 281 119.722 281 128.333C281 138.611 279.022 148.3 275.067 157.4C271.106 166.494 265.722 174.444 258.917 181.25C252.111 188.056 244.161 193.439 235.067 197.4C225.967 201.356 216.278 203.333 206 203.333ZM206 186.667C222.111 186.667 235.861 180.972 247.25 169.583C258.639 158.194 264.333 144.444 264.333 128.333C264.333 112.222 258.639 98.4723 247.25 87.0834C235.861 75.6945 222.111 70 206 70C189.889 70 176.139 75.6945 164.75 87.0834C153.361 98.4723 147.667 112.222 147.667 128.333C147.667 144.444 153.361 158.194 164.75 169.583C176.139 180.972 189.889 186.667 206 186.667Z",
    fill: "var(--card-thumbnail-fg)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3803_175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "var(--card-thumbnail-fg)",
    transform: "translate(24 16)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3803_175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "var(--card-thumbnail-fg)",
    transform: "translate(366 10)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3803_175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "var(--card-thumbnail-fg)",
    transform: "translate(372 16)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_3803_175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "var(--card-thumbnail-fg)",
    transform: "translate(320 10)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_3803_175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "var(--card-thumbnail-fg)",
    transform: "translate(326 16)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.a3b7c838d16d5537c1ed5b94ff4cba72.svg";
export { ForwardRef as ReactComponent };